module.exports = __webpack_public_path__ + "static/WS_appflows_fisica_3-df3bd3fcaa94c587a5d5ab6f9e697b6c.gif";